const SESSION_BOOTSTRAP_PATHS = [
  '/auth/login',
  '/auth/mfa/verify',
  '/auth/refresh',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/invitations/accept',
  '/passkeys/authenticate/',
  '/public/',
];

export function shouldBlockForInvalidSession(url?: string) {
  if (!url) return true;
  return !SESSION_BOOTSTRAP_PATHS.some(path => url === path || url.startsWith(path));
}
